import { render, staticRenderFns } from "./BannerAdvert.vue?vue&type=template&id=e2e3c7c6&"
import script from "./BannerAdvert.vue?vue&type=script&lang=js&"
export * from "./BannerAdvert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports